<template>
    <div> <!-- Element rădăcină -->
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('gestiune.suppliers')"></general-top-bar> -->

      <div class="row">
        <!-- Search -->
        <div class="col-md-3">
            <div class="form-group">
                <label for="searchInput">{{ $t('gestiune.searchSuppliers') }}</label>
                <el-input
                    id="searchInput"
                    v-model="searchQuery"
                    placeholder="Search by distributor name"
                    clearable
                ></el-input>
            </div>
        </div>

        <!-- Filter by Provider -->
        <div class="col-md-3">
            <div class="form-group">
                <label>{{ $t('gestiune.filterByProvider') }}</label>
                <el-select v-model="filterForm.provider" placeholder="Filter by provider">
                    <el-option label="Provider A" value="providerA"></el-option>
                    <el-option label="Provider B" value="providerB"></el-option>
                </el-select>
            </div>
        </div>

        <!-- Filter by Tag -->
        <div class="col-md-3">
            <div class="form-group">
                <label>{{ $t('gestiune.filterByTag') }}</label>
                <el-select v-model="filterForm.tag" placeholder="Filter by tag">
                    <el-option label="Tag A" value="tagA"></el-option>
                    <el-option label="Tag B" value="tagB"></el-option>
                </el-select>
            </div>
        </div>

        <!-- Filter by Quantity -->
        <div class="col-md-3">
            <div class="form-group">
                <label>{{ $t('gestiune.filterByQuantity') }}</label>
                <el-select v-model="filterForm.quantity" placeholder="Enter quantity">
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                </el-select>
            </div>
        </div>
      </div>

      <div class="card mar-to-15">
        <div class="card-content">
        <div class="data-table">
            <el-table :data="tableData">
                <el-table-column label="" prop="rawMaterial">
                    <template slot-scope="scope">
                        <span :class="scope.row.type === 'Marfă' ? 'item-marfa' : 'item-materie-prima'">
                            {{ scope.row.type }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('gestiune.nume')"></el-table-column>
                <el-table-column prop="unitPrice" :label="$t('gestiune.unitPrice')"></el-table-column>
                <el-table-column prop="inStock"  :label="`${$t('gestiune.inStock')} / ${$t('gestiune.necessary')}`"></el-table-column>
                <el-table-column prop="inStock"  :label="`${$t('gestiune.inStock')} / ${$t('gestiune.necessary')}`"></el-table-column>
                <el-table-column
                    :label="$t('general.actions')">
                    <template slot-scope="scope">
                        <button
                            class="btn add mar-rt-10"
                            :title="$t('general.add') + ' ' + $t('settingUsers.single')"
                            @click="yourAddFunction(scope.row)">
                            <img src="/static/img/icons/add.png">
                            {{ $t('general.add') }}
                        </button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        </div>
      </div>
    </div>
</template>

  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    export default {
      components: {
        // GeneralTopBar
      },
      data () {
        return {
          tableData: [
            {
              type: 'Materie Prima',
              name: 'Exemplu 1',
              unitPrice: 100,
              inStock: '100 / 50 Buc'
            }
          ],
          searchQuery: '',
          filterForm: {
            provider: '',
            tag: '',
            quantity: ''
          }
        }
      },
      methods: { }
    }
  </script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.el-select {
    width: 100%;
}
.item-marfa {
  color: blue; /* Text albastru pentru marfă */
  border: 1px solid blue; /* Border albastru */
  padding: 5px; /* Padding pentru a face elementul să arate bine */
  border-radius: 3px; /* Colțuri rotunjite */
}

.item-materie-prima {
  color: purple; /* Text mov pentru materie prima */
  border: 1px solid purple; /* Border mov */
  padding: 5px;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementOrdersSuppliers.vue